import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Notice } from "../models/notice";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import { CacheKey } from "../models/cacheKey";

export function useNotice(artistId: number, eventId: number, rewardId: number) {
  const queryClient = useQueryClient();

  const { mutateAsync: leaveNotice, isPending } = useMutation({
    mutationFn: async (notice: Notice) => {
      if (artistId && eventId && rewardId) {
        if (notice.id != null) {
          // modify existing notice
          const dto = {
            isPrimary: notice.isPrimary,
            title: notice.title,
            content: notice.content,
            images: notice.images,
          };
          const response = await HttpClient.request(
            OnSiteApi.modifyNotice(artistId, eventId, rewardId, notice.id, dto),
          );
          if (response.status >= 300) {
            throw new Error("Failed to modify notice");
          }
        } else {
          // create new notice
          const dto = {
            isPrimary: notice.isPrimary,
            targetRewardIds: [rewardId],
            title: notice.title,
            content: notice.content,
            images: notice.images,
          };
          const response = await HttpClient.request(
            OnSiteApi.leaveNotice(artistId, eventId, rewardId, dto),
          );
          if (response.status < 300) {
            await queryClient.invalidateQueries({
              queryKey: [CacheKey.getCheckInDetail, eventId],
            });
          } else {
            throw new Error("Failed to create notice");
          }
        }

        await queryClient.invalidateQueries({
          queryKey: [CacheKey.getNotices, eventId, rewardId],
        });
      }
    },
  });
  return { leaveNotice, isPending };
}
